import { range } from "lodash";

const REFERENCE_EVENT_FIELD = (name: any) => ({
  type: "SELECT",
  label: "Event",
  placeholder: "Event",
  name: `${name}.data.referenceEvent`,
  options: [
    { label: "Task Starts", value: "start_at" },
    { label: "Task Due Date", value: "due_at" },
  ],
});

const OFFSET_DIRECTION_FIELD = (name: any) => ({
  type: "SELECT",
  label: "Before/After/On",
  placeholder: "Before/After/On",
  name: `${name}.data.offsetDirection`,
  options: [
    { label: "Before", value: "before" },
    { label: "After", value: "after" },
    { label: "On", value: "exact" },
  ],
});

const COMBINED_REMINDER_OFFSET_EVENT_FIELD = (name: any) => ({
  type: "SELECT",
  label: "When",
  placeholder: "When",
  options: [
    { label: "After Task Starts", value: { offsetDirection: "after", referenceEvent: "start_at" } },
    { label: "Before Task Due Date", value: { offsetDirection: "before", referenceEvent: "due_at" } },
    { label: "On Task Due Date", value: { offsetDirection: "exact", referenceEvent: "due_at" } },
    { label: "After Task Due Date", value: { offsetDirection: "after", referenceEvent: "due_at" } },
  ],
});

const OFFSET_VALUE_FIELD = (name: any) => ({
  type: "SELECT",
  label: "Timing",
  placeholder: "Number",
  name: `${name}.data.offsetValue`,
  options: range(1, 120).map((value) => ({ label: value.toString(), value })),
});

const OFFSET_UNIT_FIELD = (name: any) => ({
  type: "SELECT",
  label: "Day/Week/Month",
  placeholder: "Day/Week/Month",
  name: `${name}.data.offsetUnit`,
  options: [
    { label: "Day(s)", value: "day" },
    { label: "Week(s)", value: "week" },
    { label: "Month(s)", value: "month" },
    { label: "Monday(s)", value: "monday" },
    { label: "Tuesday(s)", value: "tuesday" },
    { label: "Wednesday(s)", value: "wednesday" },
    { label: "Thursday(s)", value: "thursday" },
    { label: "Friday(s)", value: "friday" },
    { label: "Saturday(s)", value: "saturday" },
    { label: "Sunday(s)", value: "sunday" },
  ],
});

export function reminderSchedulingFields(name: any) {
  return {
    combinedOffsetEvent: COMBINED_REMINDER_OFFSET_EVENT_FIELD(name),
    offsetDirection: OFFSET_DIRECTION_FIELD(name),
    referenceEvent: REFERENCE_EVENT_FIELD(name),
    offsetValue: OFFSET_VALUE_FIELD(name),
    offsetUnit: OFFSET_UNIT_FIELD(name),
  };
}
